import "@NA/Store/Reducer/CustomReducer/CustomReducer";
import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// const widgets = IS_PRODUCTION
//     ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
//     : require.context("./Widgets", true, /\.tsx$/);
// // enable hot module reloading for widgets
// const onHotWidgetReplace = addWidgetsFromContext(widgets);
// if (module.hot) {
//     module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
// }

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

const store = require.context("./Store", true);
store.keys().forEach(key => store(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));
// values: [0, 576, 768, 992, 1200],
// maxWidths: [576, 576, 768, 992, 1440],
setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 1080, 1200],
        maxWidths: [576, 576, 768, 1080, 1440],
    },
    typography: {
        fontFamilyImportUrl:
            // "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800&display=swap",
            "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&display=swap",

        body: {
            fontFamily: "Nunito Sans",
            size: "1rem",
            css: css`
                outline: none;
            `,
        },
        p: {
            fontFamily: "Nunito Sans",
            size: "1rem",
        },

        headerPrimary: {
            fontFamily: "Nunito Sans",
            size: "1rem",
        },
        headerSecondary: {
            fontFamily: "Nunito Sans",
            size: "14px",
        },
        headerTertiary: {
            fontFamily: "Nunito Sans",
            size: "14px",
        },
        h1: {
            fontFamily: "Nunito Sans",
            size: "36px",
        },
        h2: {
            fontFamily: "Nunito Sans",
            size: "30px",
        },
        h3: {
            fontFamily: "Nunito Sans",
            size: "24px",
        },
        h4: {
            fontFamily: "Nunito Sans",
            size: "20px",
        },
        h5: {
            fontFamily: "Nunito Sans",
            size: "18px",
        },
        h6: {
            fontFamily: "Nunito Sans",
            size: "16px",
        },
    },
    formField: {
        defaultProps: {
            labelProps: {
                color: `${getColor("text.main")}`,
                fontFamily: "Nunito Sans",
                size: "14px",
                transform: "capitalize",
                css: css`
                    .masked-label {
                        color: ${getColor("text.main")};
                        font-family: "sans-serif";
                        font-size: 14px;
                        margin-left: 3px;
                        font-weight: 500;
                    }
                `,
            },
            cssOverrides: {
                formInputWrapper: css`
                    margin-top: 5px !important;
                `,
                inputSelect: css`
                    border-radius: 6px;
                    font-size: 14px;
                    padding: 9px 15px;
                    &:focus {
                        outline-color: ${getColor("common.background")};
                        outline-style: solid;
                        outline-width: 1px;
                        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
                        border-color: #bbb; // color not present in style guide
                        background-color: ${getColor("common.background")};
                    }
                `,
            },
        },
    },
    pagination: {
        defaultProps: {
            cssOverrides: {
                pagination: css`
                    justify-content: center;
                `,
                currentButton: css`
                    color: #00142c; // color not present in style guide
                    background: ${getColor("common.accent")};
                    width: auto;
                    min-height: 43px;
                    min-width: 43px;
                    border-radius: 50%;
                    &:not(:disabled) {
                        &:hover {
                            background: ${getColor("common.accent")};
                            text-decoration: none !important;
                        }
                        &:focus {
                            outline: none;
                        }
                    }
                `,
                linkList: css`
                    button {
                        &:not(:disabled) {
                            &:hover {
                                color: ${getColor("primary")};
                                background: none;
                                text-decoration: underline;
                            }
                            &:focus {
                                outline: none;
                            }
                        }
                    }
                `,
            },
            selectProps: {
                cssOverrides: {
                    formField: css`
                        width: 240px;
                        padding-right: 15px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    padding-right: 0px;
                                `,
                                css`
                                    padding-right: 0px;
                                `,
                                css`
                                    padding-right: 0px;
                                `,
                                css`
                                    width: 260px;
                                `,
                                null,
                            ])}
                    `,
                },
                labelProps: {
                    css: css`
                        width: 175px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                null,
                                null,
                                css`
                                    width: 226px;
                                `,
                                null,
                            ])}
                    `,
                },
            },
        },
    },
    tag: {
        defaultProps: {
            css: css`
                background: ${getColor("primary")};
                align-items: center;
                button {
                    background: ${getColor("primary")};
                    &:hover {
                        background: ${getColor("primary")};
                    }
                }
            `,
        },
    },
    link: {
        defaultProps: {
            css: css`
                outline: none;
                > ${TypographyStyle} {
                    outline: none;
                }
            `,
        },
    },

    button: {
        defaultProps: {
            css: css`
                outline: none;
            `,
        },
    },
    radio: {
        defaultProps: {
            css: css`
                input:checked + label::after {
                    content: "";
                    display: block;
                    height: 10px;
                    width: 10px;
                    border-radius: 50%;
                    background: ${getColor("primary")};
                    position: absolute;
                    left: 4px;
                    top: calc(50% - 5px);
                    cursor: pointer;
                }
                input + label::before {
                    content: "";
                    box-sizing: border-box;
                    display: inline-block;
                    height: 18px;
                    width: 18px;
                    border-radius: 50%;
                    border: 1px solid ${getColor("common.border")};
                    margin-right: 10px;
                    cursor: pointer;
                }
                input:checked:not(:disabled) + label::before {
                    border-color: ${getColor("primary")};
                    background: ${getColor("common.background")};
                }
                input:focus + label::before {
                    box-shadow: none;
                }
                &:hover {
                    input + label::after {
                        content: "";
                        display: block;
                        height: 10px;
                        width: 10px;
                        border-radius: 50%;
                        background: ${getColor("primary")};
                        position: absolute;
                        left: 4px;
                        top: calc(50% - 5px);
                    }
                    input + label::before {
                        content: "";
                        box-sizing: border-box;
                        display: inline-block;
                        height: 18px;
                        width: 18px;
                        border-radius: 50%;
                        border: 1px solid ${getColor("common.border")};
                        margin-right: 10px;
                    }
                    input:not(:disabled) + label::before {
                        border-color: ${getColor("primary")};
                        background: ${getColor("common.background")};
                    }
                    input:focus + label::before {
                        box-shadow: none;
                    }
                }
            `,
        },
    },
    checkbox: {
        defaultProps: {
            css: css`
                /* 18 8 9 17 6 13 in case we need to match like qa site we need to ovveride the Check.tsx file and place points in polyline 20 6 9 17 4 12 */
                span[role="checkbox"] {
                    border-radius: 0px;
                    height: 18px;
                    width: 18px;
                    > svg {
                        height: 18px;
                        width: 18px;
                        stroke-width: 4px;
                        stroke-linecap: square;
                    }
                    &:focus {
                        box-shadow: none;
                    }
                }
            `,
        },
    },
});
